export default {"src":"/_next/static/media/AlexAvatar.26f30433.svg","height":72,"width":71,"blurWidth":0,"blurHeight":0};